@if (isEntityInRyanInstance) {
    <div style="display: flex; justify-content: space-between;">
        <div>
            <span style="font-weight: bold;">DR Team Retrieves</span>
            <fieldset [disabled]="currentData.useTopLevelCompanySettings || entity.type !== 'company' || !editMode">
                <div class="checkbox">
                    <label>
                        <input type="checkbox" [(ngModel)]="currentData.drTeamRetrievesRE" data-qa="team-retrieves-re">
                        RE
                    </label>
                </div>
                <div class="checkbox">
                    <label>
                        <input type="checkbox" [(ngModel)]="currentData.drTeamRetrievesPP" data-qa="team-retrieves-pp">
                        PP
                    </label>
                </div>
                <div class="checkbox">
                    <label>
                        <input type="checkbox" [(ngModel)]="currentData.drTeamRetrievesMN" data-qa="team-retrieves-mn">
                        MN
                    </label>
                </div>
                <div class="checkbox">
                    <label>
                        <input type="checkbox" [(ngModel)]="currentData.drTeamRetrievesCA" data-qa="team-retrieves-ca">
                        CA
                    </label>
                </div>
            </fieldset>
        </div>
        @if (isSubsidiary) {
            <div class="checkbox">
                <label>
                    <input type="checkbox"
                           [(ngModel)]="currentData.useTopLevelCompanySettings"
                           [disabled]="!topLevelData || !editMode"
                           (change)="useTopLevelChanged()"
                           data-qa="team-retrieves-use-top-level"> Use Top Level Company Settings
                </label>
            </div>
        }
    </div>
}
@if (showTaxFeedToggle) {
    <div style="display: flex; gap: 10px; align-items: center; margin-bottom: 10px;">
        <span style="font-weight: bold;">TaxFeed:</span>
        <ws-switch [(ngModel)]="taxFeedIsEnabled"
                   [disabled]="taxFeedToggleDisabled"
                   (selectedOptionChanged)="taxFeedEnabledChanged($event)"
                   data-qa="team-retrieves-taxfeed-toggle">
        </ws-switch>
    </div>
}
